import * as React from 'react'

export default function HomeMenu() {
    return (
        <sp-sidenav-item href="/" label="Home">
            <sp-icon-home slot="icon"></sp-icon-home>
        </sp-sidenav-item>
    )
}
